module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai/bg_nagaitop03-731a701af9bb6d11d9ac06a03ba975ae.jpg";